import { LuceneExpression, toString as luceneToString } from 'lucene';

export function batchesFilter(batchReferences?: string[]) {
	if (!batchReferences || batchReferences.length === 0) {
		return undefined;
	}
	let allCondition: LuceneExpression;
	allCondition = {
		field: 'batchReference',
		term: batchReferences[0],
		quoted: true
	};
	for (const batchReference of batchReferences) {
		const rightPart = {
			field: 'batchReference',
			term: batchReference,
			quoted: true
		};
		allCondition = {
			left: allCondition,
			operator: 'OR',
			right: rightPart,
			parenthesized: true
		};
	}

	return luceneToString(allCondition);
}
